import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../Assets/Images/globalct-logo.png';

const Header: React.FC = () => {
  const location = useLocation();
  const locations = location.pathname.split('/');

  return (
    <header className="header-home header scrolled">
      <nav className="navbar fixed-top">
        <Link to="/">
          <img
            className="navbar-brand-regular navbar-brand"
            id="header-logo"
            src={logo}
            alt="logo"
            width="118"
          />
        </Link>
        <ul className="nav navbar-right">
          <li className="nav-item">
            <Link
              className={`nav-link ${
                locations.at(1) === 'formular' ? 'active' : ''
              }`}
              to={`formular${
                locations.at(2) !== undefined
                  ? '/' + locations.at(2)
                  : ''
              }`}
            >
              Formular
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                locations.at(1) === 'rechner' ? 'active' : ''
              }`}
              to={`rechner${
                locations.at(2) !== undefined
                  ? '/' + locations.at(2)
                  : ''
              }`}
            >
              Rechner
            </Link>
          </li>
        </ul>
        <ul className="nav navbar-left">
          <li className="nav-item">
            <Link
              className="nav-link"
              to={`/${locations.at(1)}/upload`}
            >
              Hochladen
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className="nav-link"
              to={`/${locations.at(1)}/report`}
            >
              Auswertung
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
